<template>
  <div>
    <div
      id="contactModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <form
            method="POST"
            action="/"
            @submit.prevent="submitForm($event)"
          >
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                Get in touch
              </h4>
            </div>
            <div class="modal-body">
              <p>
                Get in touch if you want to know more about the Urban Dynamic
                Model or are interested in using it in your project.
              </p>
              <div>
                <div class="form-group">
                  <label for="inputName">Your name</label>
                  <input
                    id="inputName"
                    v-model="name"
                    type="text"
                    class="form-control"
                    placeholder="Enter your name"
                    required
                  >
                </div>
                <br>
                <div class="form-group">
                  <label for="inputEmail1">Your email</label>
                  <input
                    id="inputEmail1"
                    v-model="email"
                    type="email"
                    class="form-control"
                    placeholder="Enter your email"
                    required
                  >
                </div>
                <br>
                <div class="form-group">
                  <label for="inputMessage">Your message</label>
                  <textarea
                    v-model="message"
                    class="form-control"
                    rows="5"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-primary"
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";
export default {
  data() {
    return {
      name: "",
      email: "",
      message: ""
    };
  },
  created() {
    this.$root.$data.eventHub.$on("show-contact-modal", this.displayModal);
  },
  methods: {
    displayModal: function() {
      $("#contactModal").modal("show");
    },
    submitForm: function(event) {
      if (event) {
        event.preventDefault();
      }
      if (!this.name || !this.email || !this.message) {
        alert("Please fill out all details");
        return;
      }

      var _this = this;

      $.ajax({
        type: "POST",
        url: "/submit-contact-form/",
        data: {
          email: this.email,
          name: this.name,
          message: this.message
        },
        success: function() {
          _this.email = "";
          _this.name = "";
          _this.message = "";
          $("#contactModal").modal("hide");
        },
        error: function(error) {
          alert("There is an error: " + error);
          $("#contactModal").modal("hide");
        }
      });
    }
  }
};
</script>
